import { render } from "./diy-toggle.vue?vue&type=template&id=9b4362d0&scoped=true"
import script from "./diy-toggle.vue?vue&type=script&lang=js"
export * from "./diy-toggle.vue?vue&type=script&lang=js"

import "./diy-toggle.vue?vue&type=style&index=0&id=9b4362d0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b4362d0"]])

export default __exports__